import store from "@/store";
import {
  RTC_TYPE,
  REMOVE_USER_ADDITION_SUFFIX,
  REMOVE_USER_BGM_SUFFIX,
  RTC_DEFAULT_RUNTIME_PARAMETERS,
  PHONE_MIC_ID,
} from '_lib/constants/rtc'
import {
  CHANNEL_USER_ACTIVE_VOLUME,
} from '@/common/constants/channel'
import { reportChatTime } from "_api/report";

let volcAPI = null, volcElectronAPI = null, trtcElectronAPI = null, trtcAPI = null

let rtcLogPathObj = null

// 根据 线路类型 获取真正要加载的rtc type
export function getRealRtcType(type, use_electron_trtc) {
  if (type === 'trtc') { // trtc根据清晰模式开关判断加载Electron还是web sdk
    return use_electron_trtc ? RTC_TYPE.TRTC_ELECTRON : RTC_TYPE.TRTC
  } else if (type === 'volc') { // volc根据环境判断加载Electron还是web sdk
    return process.env.IS_CLIENT ? RTC_TYPE.VOLC_ELECTRON : RTC_TYPE.VOLC
  }
}

export function loadRtcAPI(type) {
  if (type === RTC_TYPE.TRTC) {
    return loadTrtcWebAPI()
  } else if (type === RTC_TYPE.TRTC_ELECTRON) {
    return loadTrtcElectronAPI()
  } else if (type === RTC_TYPE.VOLC) {
    return loadVolcWebAPI()
  } else if (type === RTC_TYPE.VOLC_ELECTRON) {
    return loadVolcElectronAPI()
  }
}

export async function getRtcLogPath() {
  if (!rtcLogPathObj) {
    rtcLogPathObj = await window.getRtcSdkLogPath()
    window.getRtcSdkLogPath = null
  }
  return rtcLogPathObj
}

export function loadTrtcWebAPI() {
  return new Promise((resolve, reject) => {
    if (trtcAPI) {
      resolve(trtcAPI)
    } else {
      import('./sdk/thirdPartySdk/trtc5API').then((Trtc) => {
        trtcAPI = Trtc.default
        resolve(trtcAPI)
      }).catch((err) => {
        reject(err)
      })
    }
  })
}

export function loadTrtcElectronAPI() {
  return new Promise((resolve, reject) => {
    if (trtcElectronAPI) {
      resolve(trtcElectronAPI)
    } else {
      import('./sdk/thirdPartySdk/electronTrtcApi').then((electronTrtc) => {
        trtcElectronAPI = electronTrtc.default
        resolve(trtcElectronAPI)
      }).catch((err) => {
        reject(err)
      })
    }
  })
}

export function loadVolcWebAPI() {
  return new Promise((resolve, reject) => {
    if (volcElectronAPI) {
      resolve(volcElectronAPI)
    } else {
      import('./sdk/thirdPartySdk/volcengineApi').then((Volc) => {
        volcElectronAPI = Volc.default
        resolve(volcElectronAPI)
      }).catch((err) => {
        reject(err)
      })
    }
  })
}

export function loadVolcElectronAPI() {
  return new Promise((resolve, reject) => {
    if (volcAPI) {
      resolve(volcAPI)
    } else {
      import('./sdk/thirdPartySdk/volcElectronApi').then((Volc) => {
        volcAPI = Volc.default
        resolve(volcAPI)
      }).catch((err) => {
        reject(err)
      })
    }
  })
}

export function getAudioDevices() {
  return new Promise((resolve, reject) => {
    navigator?.mediaDevices.enumerateDevices()
      .then(devices => {
        console.log(devices)
        let micDevices = [], voiceDevices = []
        devices.forEach(device => {
          if (!device.deviceId) return
          if (device.kind === 'audioinput') {
            micDevices.push(device.toJSON())
          } else if (device.kind === 'audiooutput') {
            voiceDevices.push(device.toJSON())
          }
        })
        console.log([micDevices, voiceDevices])
        resolve([micDevices, voiceDevices]);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export async function getAudioDevicesElectron() {
  const data = await window.electronAPI.getAudioDevices()
  return [
    data.in.map(v => ({
      label: v.name,
      deviceId: v.id
    })),
    data.out.map(v => ({
      label: v.name,
      deviceId: v.id
    }))
  ]
}

export function trtcDbToVolume(db) {
  const permutation = [
    0, 1, 2, 3, 4, 4, 5, 5, 5, 5, 6, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9,
  ];
  const reversePermutation = [0, 1, 2, 3, 4, 6, 10, 15, 19, 22, 32];

  const pcm = Math.pow(10, db / 20) * 32767;
  const tens = permutation[Math.floor(pcm / 1000)];
  const ones =
    (10 * (pcm - reversePermutation[tens] * 1000)) / (1000 * (reversePermutation[tens + 1] - reversePermutation[tens]));
  return tens * 10 + ones;
}

export function handleDevices(devices = [], origin_devices = [], { id, name }, firstInitAllDevice) {
  let choose = null
  devices.map((v) => {
    if (!v.deviceId) {
      v.deviceId = v.device_id; // volc是device_id, 归一化为deviceId
    }
    v.value = v.deviceId;
    // 优先匹配和上次设备id一致的设备作为选择设备
    if (v.deviceId == id) {
      choose = v
    }
    v.label = v.deviceName || v.device_name || v.label // trtc electronsdk中设备列表返回名称是deviceName, volc是device_name, 归一化为label

    // 由于不同sdk实现不同，electronsdk获取的id和websdk获取的不一致，次优先级用名称是否包含来判断
    if (!choose && name
      && (v.label.includes(name)
        || name.includes(v.label))) {
      choose = v
    }

    // 设置新设备标记
    let originDevice = origin_devices.find(device => device.deviceId == v.deviceId)
    if (!firstInitAllDevice) { // 首次加载时将所有设备的新设备标记置为false
      v.isNew = false
    } else { // 更新设备列表时，如果是已有此设备，新设备标记和之前一致，如果不是已有设备，设置新设备标记为true
      v.isNew = originDevice ? originDevice.isNew : true
    }
    return v;
  });
  if (id === PHONE_MIC_ID && store.getters.is_phone_mic_connecting) { // 如果是手机mic，不切换设备，直接返回
    return { id, name }
  }
  // 没有默认设备选择第一个设备作为默认设备
  if (!choose && devices[0]) {
    choose = devices[0]
  }
  return {
    id: choose && choose.deviceId || '',
    name: choose && choose.label || ''
  }
}

export function rtcJoinLog(data, RtcType, setting_data) {
  let logData = JSON.parse(JSON.stringify(data))
  delete logData.private_map_key
  delete logData.token
  logData.members = logData.members?.map(({ user_id }) => user_id)
  clientLog('rtc-join', {
    RtcType: RtcType,
    data: logData,
    device: {
      curMicId: setting_data.curMicId,
      curVoiceId: setting_data.curVoiceId,
    }
  })
}

export function isUserVolumeActive(volume) {
  return volume > CHANNEL_USER_ACTIVE_VOLUME
}

export function isUnverifiedUser(user_id) {
  user_id = REMOVE_USER_BGM_SUFFIX(REMOVE_USER_ADDITION_SUFFIX(user_id))
  if (store.getters.cur_channel_data.members) {
    let user = store.getters.cur_channel_data.members.find((user) => user_id == user.user_id)
    if (user) {
      return !user.verified
    }
  }
  return false
}

export function getRuntimeParam(type) {
  if (process.env.IS_CLIENT) {
    type = type.replace('_electron', '')
    let k = `${type}${store.getters.user_account_settings.system_audio_handle ? '' : '_close'}`
    return store.getters.global_config.runtime_parameters?.[`${k}_runtime_parameter`] || RTC_DEFAULT_RUNTIME_PARAMETERS[k]
  }
  return ''
}

// 埋点上报
export function reportTime(type) {
  let cur_channel_data = store.getters.cur_channel_data
  let user_id = store.getters.user_info.user_id
  switch (type) {
    case 'start':
      if (window._chatReportLoop) clearTimeout(window._chatReportLoop)
      let reportFunc = () => {
        let { start_time, channel_id, room_id } = cur_channel_data
        let my_screen_sharing = store.getters.my_screen_sharing
        let screen_sharing_info = store.getters.screen_sharing_info
        if (!(start_time && channel_id && room_id)) {
          if (window._chatReportLoop) clearTimeout(window._chatReportLoop)
          return
        }
        reportChatTime({
          start_time,
          channel_id,
          room_id,
          event_type: 'video_time',
          is_screen_share_emcee: !!my_screen_sharing,
          is_screen_share_audience: !!(screen_sharing_info.user_id && !(user_id == screen_sharing_info.user_id) )
        })
        if (window._chatReportLoop) clearTimeout(window._chatReportLoop)
        let interval = store.getters.api_poll_interval('video_time', 60, true)
        window._chatReportLoop = setTimeout(reportFunc, interval * 1000)
      }
      reportFunc()
      break
    case 'stop':
      let { start_time, channel_id, room_id } = cur_channel_data
      if (window._chatReportLoop) clearTimeout(window._chatReportLoop)
      if (!(start_time && channel_id && room_id)) {
        return
      }
      reportChatTime({
        start_time,
        channel_id,
        room_id,
        event_type: 'video_end'
      })
      break
  }
}

/**
 * 获取屏幕共享dom
 * @param {*} channel_data 
 * @returns {HTMLElement | null} 屏幕共享dom
 */
export function getScreenShareDom(channel_data) {
  const { channel_id } = channel_data
  return document.querySelector(`#screen-block-${channel_id}`)
}